/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

import { displayTitlePDF } from '../utilPdf'

export const blockTitle = (doc, title, nb) => {
	return displayTitlePDF(doc, title, null, nb)
}
